// --------------------------------------------------------------
// Created On: 2021-12-03
// Author: Zachary Thomas
//
// Last Modified: 2026-09-02
// Modified By: Dimitra Weinstein
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import styles from "./ValidateAssetButton.module.scss";

// When clicked, this button pulls up the validation modal for the specified asset.
export default function ValidateAssetButton(props: Props): Component {
  return (
    <Fragment>
      <button
        data-test="validate-asset-button"
        className={`${props.smallButton ? styles.smallBody : styles.body} btn btn-primary ${props.className}`}
        type="button"
        disabled={props.disabled || props.assetId === null}
        onClick={() => props.onShowValidationModal()}
      >
        <span
          className="d-none d-lg-inline-block d-xl-none d-xxl-inline-block pb-1 align-items-center"
          style={{ fontSize: "0.95rem" }}
        >
          Validate
        </span>
        <span className="d-inline-block d-lg-none d-xl-inline-block d-xxl-none" style={{ fontSize: "0.95rem" }}>
          Validate
        </span>
      </button>
    </Fragment>
  );
}

interface Props {
  assetId: number | null;
  deviceId: number | null;
  deviceType: string | null;
  smallButton?: boolean;
  disabled?: boolean;
  className?: string;
  onShowValidationModal: () => void;
}
